<template>
  <div>
    <!-- <h1>Välkommen</h1>
 -->
    <b-row> </b-row>
    <b-row>
      <b-col cols="12" sm="6" v-if="HasPermission('ADM')">
        <b-card>
          <b-card-header>
            Översikt
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col cols="2">Leveransdag:</b-col>
              <b-col cols="8">
                <datepicker v-model="dateFilter" @change="RefreshStats()" @input="RefreshStats()" :stepper="true">
                </datepicker>
              </b-col>
            </b-row>

            <barchartdash :title="'Sändningar'" :url="'/api/Dash/GetGenericStats?dateFilter=' + dateFilter"
              v-bind:refresher="refresher">
            </barchartdash>

            <!-- <barchartdash :title="'Apimeddelanden (unika MsgRefId)'"
              :url="'/api/Dash/GetApiMessagesStats?dateFilter=' + dateFilter" v-bind:refresher="refresher">
            </barchartdash>
            <bookingtrenddash v-bind:refresher="refresher" v-bind:date="dateFilter" :titleField="'DeliveryDateText'"
              :rowField="'TerminalName'" :cellField="'Cnt'"></bookingtrenddash> -->
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="6" v-if="HasPermission('MANUALBOOKING')">
        <b-card>
          <b-card-title>Manuella bokningar</b-card-title>
          <b-card-body>
            Skapa bokningar manuellt.
            <p><b-button to="/bookingltdlist">Gå till manuella bokningar</b-button></p>
          </b-card-body>
        </b-card>
      </b-col>  
    </b-row>
  </div>
</template>

<script>
//import { Component, Vue } from "vue-property-decorator";
import sidebar from "../components/sidebar.vue";
import topbar from "../components/topbar.vue";
//import statdash from "../views/dash/statdash.vue";
import barchartdash from "../views/dash/barchartdash.vue";
// import dashgrid from "../views/dash/dashgrid.vue";
import bookingtrenddash from "../views/dash/bookingtrenddash.vue";
import datepicker from "../components/datepicker.vue";
import moment from "moment";
import User from "../lib/user";
const usr = new User();

export default {
  name: "Home",
  components: {
    sidebar,
    topbar,
    //statdash,
    barchartdash,
    datepicker,
    // dashgrid,
    bookingtrenddash,
  },
  data() {
    return {
      refresher: 0,
      dateFilter: moment(new Date()).format("YYYY-MM-DD"),
      widgets: []
    };
  },
  created: function () {


  },
  methods: {
    HasPermission(perm) {
      return usr.HasPermission(perm);
    },

    RefreshStats() {
      this.refresher++;
    },
    GetWidgets() {
      return [
        {
          box: {
            id: "widget0",
            text: "first widget",
            layout: {
              x: 0,
              y: 0,
              width: 4,
              height: 2
            }
          },
          content: {
            type: 'barchart',
            config: {
              url: '/api/Dash/GetGenericStats?dateFilter=' + this.dateFilter
            }
          }
        },
        {
          box: {
            id: "widget1",
            text: "second widget",
            layout: {
              x: 4,
              y: 0,
              width: 4,
              height: 4
            }
          }
        }
      ];
    }
  },
};

</script>
